/* eslint-disable eqeqeq */
import {
  Button,
  Col, Form, Modal,
  notification, Row,
  Upload
} from "antd";
import React, { useEffect, useState } from "react";
import { AiOutlineUpload } from "react-icons/ai";
import TextEditor from "../../../../../components/TextEditor";
import { axios, getToken, URL_API, _ } from "../../../../../utils";
import {
  base64toFile,
  beforeUploadImg,
  fileToBase64,
  resizeFile
} from "../../../../util/helper";
import { Panel, PanelBody, PanelHeader } from "../../../../util/panel";

function Branch({ history, form, ...props }) {
  const [loadValue, setLoadValue] = useState("");

  const [fileListDesktop, setFileListDesktop] = useState([]);
  const [fileDelete, setFileDelete] = useState([]);

  const [contentTextEditorName, setContentTextEditorName] = useState("");
  const [contentTextEditorAddress, setContentTextEditorAddress] = useState("");
  const [contentTextEditorOpen, setContentTextEditorOpen] = useState("");
  const [contentTextEditorTel, setContentTextEditorTel] = useState("");
  const [contentTextEditorEmail, setContentTextEditorEmail] = useState("");

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const handleClickSubmit = () => {
    form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return notification.warning({
          message: "กรุณาตรวจสอบรายการ",
          description: "กรุณากรอกข้อมูลให้ครบถ้วน",
        });
      }

      console.log({ values });

      let formData = new FormData();

      if (values.desktop_img?.file?.originFileObj)
        formData.append("desktop_img", values.desktop_img?.file?.originFileObj);

      formData.append(
        "data",
        JSON.stringify({
          ..._.omit(values, ["desktop_img"]),
          content: JSON.stringify({
            branch_name: contentTextEditorName,
            branch_address: contentTextEditorAddress,
            branch_open: contentTextEditorOpen,
            branch_tel: contentTextEditorTel,
            branch_email: contentTextEditorEmail,
          }),
        })
      );

      Modal.confirm({
        title: "ยืนยัน",
        content: "ต้องการบันทึกข้อมูลหรือไม่",
        okText: "บันทึก",
        cancelText: "ปิด",

        onOk() {
          return new Promise((resolve, reject) => {
            let url_path;
            loadValue != (null || "")
              ? (url_path = "/manage-website/contact-legacy/branch/update")
              : (url_path = "/manage-website/contact-legacy/branch");

            axios({
              method: "post",
              baseURL: URL_API,
              url: url_path,
              headers: { Authorization: "Bearer " + getToken() },
              data: formData,
            })
              .then((res) => {
                console.log(res);
                resolve("success");
              })
              .catch((err) => {
                console.log(err);
                reject(
                  err && err.response
                    ? err.response.data.message
                      ? err.response.data.message
                      : err.response.data
                    : err.message
                );
              });
          })
            .then(() => {
              Modal.success({
                title: "สำเร็จ",
                content: "บันทึกเรียบร้อย",
                okText: "ปิด",
                onOk() {
                  history.go(0);
                },
              });
            })
            .catch((reason) => {
              Modal.error({
                title: "ผิดพลาด",
                content: reason,
                okText: "ปิด",
              });
            });
        },
      });
    });
  };

  const handleRemoveDesktop = async (e) => {
    //------------------------------------check delete[index] preview
    let deleteIndex = e.uid?.toString();
    for (let i in fileListDesktop) {
      let checkIndex = fileListDesktop[i].uid.toString();
      if (deleteIndex === checkIndex) {
        console.log(fileListDesktop[i].uid);
        fileListDesktop.splice(i, 1);
        setFileListDesktop([...fileListDesktop]);
      }
    }

    //------------------------------------check delete[index] db
    if (e.uid?.toString()?.indexOf("rc-upload") === -1) {
      setFileDelete([...fileDelete, e.uid]);
    }
  };

  const handleChangeUploadDesktop = async (e) => {
    let file = e.file.originFileObj;
    if (file) {
      let img_url = "";
      if (e.file.size / 1024 / 1024 < 3) {
        img_url = await fileToBase64(file);
      } else {
        img_url = await resizeFile(file);
        file = await base64toFile(img_url, file.name);
      }
      // dispatch(ADD_MEDIA({ img_url, file }));

      setFileListDesktop([
        {
          uid: file.uid,
          status: "done",
          name: file.name,
          url: img_url,
        },
      ]);
    }
  };

  const loadContent = () => {
    axios({
      method: "get",
      baseURL: URL_API,
      url: "/manage-website/contact-legacy/branch",
      headers: { Authorization: "Bearer " + getToken() },
    })
      .then((res) => {
        console.log(res);
        let data = res.data?.data;
        setLoadValue(data);

        let loadContent = JSON.parse(data.content);

        if (loadContent) {
          setContentTextEditorName(loadContent.branch_name);
          setContentTextEditorAddress(loadContent.branch_address);
          setContentTextEditorOpen(loadContent.branch_open);
          setContentTextEditorTel(loadContent.branch_tel);
          setContentTextEditorEmail(loadContent.branch_email);
        }

        let { loadDesktopImg } = data;

        for (let i in data.files) {
          if (data.files[i].document_type == "34") {
            loadDesktopImg = [
              {
                uid: data.files[i].id,
                status: "done",
                name: data.files[i].file_name,
                url: data.files[i].azure_url,
              },
            ];
            setFileListDesktop(loadDesktopImg);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    loadContent();
  }, []);

  const { getFieldDecorator } = form;

  return (
    <>
      <Panel>
        <PanelHeader>สาขาและที่ตั้ง</PanelHeader>
        <PanelBody>
          <Form.Item layout="vertical">
            <Row gutter={24}>
              <Col md={12}>
                <Row className="mb-3">
                  <h5>ชื่อสาขา:</h5>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorName}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorName(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
              <Col md={12}>
                <Row className="mb-3 ">
                  <h5>ที่อยู่สาขา:</h5>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorAddress}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorAddress(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col md={12}>
                <Row className="mb-3">
                  <h5>เวลาทำการ:</h5>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorOpen}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorOpen(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
              <Col md={12}>
                <Row className="mb-3 ">
                  <h5>เบอร์ติดต่อสาขา:</h5>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorTel}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorTel(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
            </Row>

            <Row gutter={24}>
              <Col md={12}>
                <Row className="mb-3">
                  <h5>Email สาขา:</h5>
                  <TextEditor
                    authToken={getToken()}
                    value={contentTextEditorEmail}
                    onInit={(evt, event) => {}}
                    onEditorChange={(e) => {
                      setContentTextEditorEmail(e);
                    }}
                    onUploadSuccess={(json) => {
                      console.log(json);
                    }}
                    postBody={{ container_name: "web-content" }}
                    urlUpload={`${URL_API}/file/upload`}
                  />
                </Row>
              </Col>
            </Row>

            <Row>
              <Row gutter={24} className="mb-2">
                <Col md={12} className="mb-2">
                  <Form.Item label="Gallery สาขา : ">
                    {getFieldDecorator("desktop_img", {
                      initialValue: null,
                    })(
                      <Upload.Dragger
                        accept="image/*"
                        multiple={false}
                        fileList={fileListDesktop}
                        customRequest={dummyRequest}
                        beforeUpload={beforeUploadImg}
                        onRemove={handleRemoveDesktop}
                        onChange={handleChangeUploadDesktop}
                        listType="picture"
                      >
                        <AiOutlineUpload className="mr-3" />
                        Upload
                      </Upload.Dragger>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Row>

            <Row className="mt-3 mb-3">
              <Button
                type="primary"
                onClick={() => {
                  handleClickSubmit();
                }}
              >
                {loadValue != (null || "") ? "Update" : "Save"}
              </Button>
            </Row>
          </Form.Item>
        </PanelBody>
      </Panel>
    </>
  );
}
export default Form.create("contact-legacy-branch")(Branch);
